<svg viewBox="0 0 16 16" fill="none"
  xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_63_8879)">
    <path d="M12.2 3.80714C11.94 3.54714 11.52 3.54714 11.26 3.80714L7.99998 7.06047L4.73998 3.80047C4.47998 3.54047 4.05998 3.54047 3.79998 3.80047C3.53998 4.06047 3.53998 4.48047 3.79998 4.74047L7.05998 8.00047L3.79998 11.2605C3.53998 11.5205 3.53998 11.9405 3.79998 12.2005C4.05998 12.4605 4.47998 12.4605 4.73998 12.2005L7.99998 8.94047L11.26 12.2005C11.52 12.4605 11.94 12.4605 12.2 12.2005C12.46 11.9405 12.46 11.5205 12.2 11.2605L8.93998 8.00047L12.2 4.74047C12.4533 4.48714 12.4533 4.06047 12.2 3.80714Z" fill="#111111"/>
  </g>
  <defs>
    <clipPath id="clip0_63_8879">
      <rect width="16" height="16" fill="white"/>
    </clipPath>
  </defs>
</svg>
